module.exports = __webpack_public_path__ + "img/GALLERY-S-CROSS-3.a82ce64d.jpg";